import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-custom__header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = {
  class: "p-field-label",
  style: {"margin":"0 20px"}
}
const _hoisted_7 = {
  class: "p-field my-3",
  style: {"margin":"0 20px"}
}
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "p-field-label" }
const _hoisted_10 = { class: "mt-1 text-gray" }
const _hoisted_11 = { class: "list-blocks" }
const _hoisted_12 = { class: "form-custom d-flex align-items-center w-100" }
const _hoisted_13 = { class: "p-field mr-2" }
const _hoisted_14 = { class: "p-field-label bigger-label" }
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToggleSwitchButton = _resolveComponent("ToggleSwitchButton")
  const _component_Card = _resolveComponent("Card")
  const _component_NumberButtons = _resolveComponent("NumberButtons")
  const _component_InputText = _resolveComponent("InputText")
  const _component_CardContainer = _resolveComponent("CardContainer")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_ElScrollbar, {
          class: "dialog-scroll",
          style: {"padding":"0"}
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("AppResourceEP.SetupNumberOfBuildings")), 1)
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_Card, { class: "card--slim" }, {
                content: _withCtx(() => [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", null, [
                      _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("AppResourceEP.LinkRisersBuildings")), 1),
                      _createVNode("div", _hoisted_10, [
                        _createVNode("label", null, _toDisplayString(_ctx.$t("AppResourceEP.AutoLinkRisersAndBuildingsDescription")), 1)
                      ])
                    ]),
                    _createVNode(_component_ToggleSwitchButton, {
                      class: "ml-auto",
                      modelValue: _ctx.uniqueRiserBuildingLinking,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.uniqueRiserBuildingLinking = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_CardContainer, {
              style: {"margin":"0 20px"},
              titleIcon: 
                        require(`@/assets/images/entrancePlants/icon-building.svg`)
                        ,
              title: _ctx.titleCard,
              showActionButton: false
            }, {
              actionButton: _withCtx(() => [
                _createVNode(_component_NumberButtons, {
                  disabled: _ctx.disableBuildingCountChange,
                  disableDecrease: _ctx.buildingsCount == 0,
                  disableIncrease: !_ctx.canAddMoreBuildings,
                  lightTheme: "",
                  minValue: 0,
                  modelValue: _ctx.buildingsCount,
                  onIncrement: _ctx.addBuilding,
                  onDecrement: _ctx.removeBuilding
                }, null, 8, ["disabled", "disableDecrease", "disableIncrease", "modelValue", "onIncrement", "onDecrement"])
              ]),
              default: _withCtx(() => [
                _createVNode("ul", _hoisted_11, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildings, (building, i) => {
                    return (_openBlock(), _createBlock("li", {
                      class: "new-building",
                      key: i
                    }, [
                      _createVNode("form", _hoisted_12, [
                        _createVNode("div", _hoisted_13, [
                          _createVNode("label", _hoisted_14, _toDisplayString(`${_ctx.$t("NameBuilding")} ${i + 1}`) + ": ", 1),
                          _createVNode("div", _hoisted_15, [
                            _createVNode(_component_InputText, {
                              type: "text",
                              class: "w-100",
                              modelValue: building.name,
                              "onUpdate:modelValue": ($event: any) => (building.name = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["titleIcon", "title"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("footer", _hoisted_16, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackButton,
        label: _ctx.$t('AppResource.Back'),
        class: "p-button-text mr-3"
      }, null, 8, ["onClick", "label"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleNextButton,
        disabled: _ctx.isNextDisabled,
        label: _ctx.$t('AppResource.Continue'),
        class: "p-button-rounded p-button-raised p-button--m"
      }, null, 8, ["onClick", "disabled", "label"])
    ])
  ], 64))
}